import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import WinLogo from "../../assets/images/win/logo-win.svg";
import { useEffect } from "react";
import { Endpoints } from "../../Global/Endpoints";
import axios from "axios";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import ErrorModal from "../Security/ErrorModal";
import { validate } from "schema-utils";
import { array } from "@amcharts/amcharts4/core";

const Returntowork = () => {
  
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [zoomChoice, setZoomChoice] = useState("");
  const [validateText, setValidateText] = useState("");
  const [careerChallenge, setCareerChallenge] = useState("");
  const [sessions, setSessions] = useState("");
  const [sessionOptions, setSessionOptions] = useState([]);
  const [self, setSelf] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem("AccessToken");
  const userInfo = useSelector((state) => state.userData.userData);
  const [errors, setErrors] = useState({ zoomChoice: "", careerChallenge: "", sessions: "" });
  const [showPopup, setshowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

  useEffect(() => {
    ValidateReturntoWorkPay();
  }, []);

  const extractAmountFromLabel = (label) => {
    if (!label) return null;
    const text = String(label);

    // Prefer amounts that appear after a hyphen, with optional currency symbol and decimals
    let match = text.match(/[-–—]\s*[$£€₹]?([\d,]+)(?:\.\d+)?\b/);
    if (match) return parseInt(match[1].replace(/,/g, ""), 10);

    // Fallback: any currency amount in the string
    match = text.match(/[$£€₹]\s*([\d,]+)(?:\.\d+)?\b/);
    if (match) return parseInt(match[1].replace(/,/g, ""), 10);

    return null;
  };

  const validateForm = () => {
    const newErrors = { zoomChoice: "", careerChallenge: "", sessions: "" };
    if (!zoomChoice) newErrors.zoomChoice = "This field is required.";
    if (!careerChallenge || !careerChallenge.trim()) newErrors.careerChallenge = "This field is required.";
    if (self && !sessions) newErrors.sessions = "This field is required.";

    setErrors(newErrors);
    return !Object.values(newErrors).some(Boolean);
  };

  const SaveReturntoWork = async (e) => {
      if (!validateForm()) return;
 
        let newTab = null;
    if (e && typeof e.preventDefault === "function") {
      // Open the tab synchronously on user click
      newTab = window.open("about:blank", "_blank");
      if (newTab) {
        newTab.document.write("<html><head><title>Loading...</title></head><body><h2 style='font-family:sans-serif;text-align:center;margin-top:40px;'>Loading...</h2></body></html>");
        newTab.document.close();
      }
    }
    try {
      const params = {
        UserName: userInfo.PreferredName || "",
        UserEmail: userInfo.EmailID || "",
        UserPhoneno: userInfo.PhoneNumber || "",
        Contract: userInfo.ContractIdentified || "",
        IsZoom: zoomChoice,
        CareerChallenge: careerChallenge,
        // (Number(String(sessions).match(/\d+/)?.[0])|| "")
        NoOfSessions: sessions || "",
        Payment: validateText || "",
        // extractAmountFromLabel(sessions)
      };
      setIsLoading(true);
      const response = await axios.post(
        Endpoints.SaveReturntoWork,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.result === 1) {
             if (newTab) {
          newTab.location = response.data.resultText;
        } else {
          window.open(response.data.resultText, "_blank");
        }
        navigate(-1);
        navigate(-1);
      } else {
        setPopupMessage(response.data.resultText || "Something went wrong while submitting. Please try again.");
        setshowPopup(true);
      }
    } catch (err) {
      console.error("Error validating return to work payment:", err);
      setPopupMessage("Something went wrong while submitting. Please try again.");
      setshowPopup(true);
    } finally {
      setIsLoading(false);
    }
  };

  const ValidateReturntoWorkPay = async () => {
    try {
      const params = {
        MemberId: userInfo.MemberID || "",
        Contract: userInfo.ContractIdentified || "",
        EmailID: userInfo.EmailID || "",
      };
      setIsLoading(true);
      const response = await axios.post(
        Endpoints.ValidateReturntoWorkPay,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );
//debugger
      setValidateText(response?.data?.validate || "");
      if (response?.data?.validate !== "Self") {
        setSelf(false);
      } else {
        setSelf(true);
      }

      if (Array.isArray(response?.data?.SessaionInfo)) {
        setSessionOptions(response.data.SessaionInfo);
      } else {
        setSessionOptions([]);
      }
    } catch (err) {
      console.error("Error validating return to work payment:", err);
      setSessionOptions([]);
      setPopupMessage("Unable to load session options. Please try again later.");
      setshowPopup(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
     {isLoading && (
        <div className="loading-container">
          <div className="loading"></div>        
          <h2 className="loading-text">{t("loading")}</h2>
        </div>
      )}
      {/* Header */}
      {/* {!isHighmarkPortal && <header>
        <nav className="navbar navbar-expand-lg container-fixed">
          <a className="navbar-brand" href="#">
            <img src={WinLogo} alt="WIN Logo" className="logo brand-logo" />
          </a>
        </nav>
      </header>} */}

      <div className="paymentstep-page-wrapper">
        <div className="paymentstep-centered-container">
          <div className="registration-block-main patient-consent-screen paymentstep-wrapper">
            {/* BACK BUTTON */}
            <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
              <button className="win-back-buttonn" onClick={() => navigate(-1)}>
                <i className="bi bi-chevron-left"></i> Back
              </button>
            </div>

            {/* MAIN CONTENT */}
            <div className="registration-form-main mt-2 paymentstep-form">
              <div className="registration-form payment-wrapper">
                <div className="registration-process-form-wrapper">
                  {/* TITLE */}
                  <h2 className="page-heading-primary mt-3 return-title">
                    Help us understand<br />
                    your goals and return-<br />
                    to-work needs
                  </h2>

                  <p className="text-mute mt-3">
                    Your responses will help us personalize your support and prepare
                    for your upcoming 1:1 session.
                  </p>

                  {/* ZOOM QUESTION */}
                  <p className="return-label mt-4">
                    Would you like to conduct this call via Zoom instead of a telephone call?
                  </p>

                  <div className="mt-2">
                    <label className="d-flex align-items-center gap-2">
                      <input
                        type="radio"
                        checked={zoomChoice === "Yes"}
                        onChange={() => {
                          setZoomChoice("Yes");
                          if (errors.zoomChoice) setErrors((e) => ({ ...e, zoomChoice: "" }));
                        }}
                        className="pink-radio"
                        aria-invalid={!!errors.zoomChoice}
                        aria-describedby={errors.zoomChoice ? "zoomChoice-error" : undefined}
                      />
                      Yes
                    </label>

                    <label className="d-flex align-items-center gap-2 mt-2">
                      <input
                        type="radio"
                        checked={zoomChoice === "No"}
                        onChange={() => {
                          setZoomChoice("No");
                          if (errors.zoomChoice) setErrors((e) => ({ ...e, zoomChoice: "" }));
                        }}
                        className="pink-radio"
                        aria-invalid={!!errors.zoomChoice}
                        aria-describedby={errors.zoomChoice ? "zoomChoice-error" : undefined}
                      />
                      No
                    </label>
                    {errors.zoomChoice ? (
                      <div id="zoomChoice-error" className="text-danger small mt-1">{errors.zoomChoice}</div>
                    ) : null}
                  </div>

                  {/* TEXTAREA */}
                  <p className="return-label mt-4">
                    What is the biggest career challenge you are currently facing that you'd like help with?
                  </p>

                  <textarea
                    className="coach-textarea-return"
                    value={careerChallenge}
                    onChange={(e) => {
                      const v = e.target.value;
                      setCareerChallenge(v);
                      if (v.trim() && errors.careerChallenge) setErrors((e) => ({ ...e, careerChallenge: "" }));
                    }}
                    aria-invalid={!!errors.careerChallenge}
                    aria-describedby={errors.careerChallenge ? "careerChallenge-error" : undefined}
                  />
                  {errors.careerChallenge ? (
                    <div id="careerChallenge-error" className="text-danger small mt-1">{errors.careerChallenge}</div>
                  ) : null}

                  {self ? (
                    <>
                      {/* SESSION COUNT - dynamically from API */}
                      <p className="return-label mt-4">
                        How many 30 minute coaching sessions are you interested in?
                      </p>

                      <div className="mt-2">
                        {sessionOptions.map((label, idx) => {
                          return (
                            <label key={idx} className="d-flex align-items-center gap-2 mt-2">
                              <input
                                type="radio"
                                checked={sessions === label}
                                onChange={() => {
                                  setSessions(label);
                                  if (errors.sessions) setErrors((e) => ({ ...e, sessions: "" }));
                                }}
                                className="pink-radio"
                                aria-invalid={!!errors.sessions}
                                aria-describedby={errors.sessions ? "sessions-error" : undefined}
                              />
                              {label}
                            </label>
                          );
                        })}
                        {errors.sessions ? (
                          <div id="sessions-error" className="text-danger small mt-1">{errors.sessions}</div>
                        ) : null}
                      </div>
                    </>
                  ) : null}

                  {/* NEXT */}
                  <div className="paymentstep-btn-wrapper mt-5">
                    <button className="win-btn-secondaryy w-100" onClick={SaveReturntoWork} disabled={isLoading}>
                      {isLoading ? "Scheduling..." : "Schedule coaching session"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          
          </div>
        </div>
      </div>

      <ErrorModal
        show={showPopup}
        onClose={() => { setshowPopup(false); }}
        message={popupMessage}
      />
    </>
  );
};

export default Returntowork;
